import { UNSPECIFIC } from './utils';

export enum WorkOrderDirection {
  DOWN = 'down',
  TOP = 'top',
  BOTH = 'both',
  UNSPECIFIC = 'sense especificar',
}

export enum Margin {
  UP = 'up',
  BOTH = 'both',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right',
  UNSPECIFIC = 'sense especificar',
}

type WorkOrderOptions = {
  id?: string;
  name: string;
  value?: string;
};

export type SubCapitolOptions = {
  id: string;
  name: string;
  elementOrdersIds: string[];
};

export type CapitolOptions = {
  id: string;
  name: string;
  subCapitolsIDs: string[];
};

type predefineOrder = {
  name: string;
  id: string;
  capitolId: string;
  subCapitolId: string;
  elementOrderId: string;
  activityId: string;
};

export type AssetsOptions = {
  id: string;
  code: string;
};

type ElementOrdersOptions = {
  id: string;
  name: string;
  subCapitolIDs: string[];
};

export type equipmentTypes = {
  id: string;
  name: string;
};

type GroupTypes = {
  concessions: WorkOrderOptions[];
  groupRoads: WorkOrderOptions[];
  groupTracks: WorkOrderOptions[];
  groupLanes: WorkOrderOptions[];
  classifications: WorkOrderOptions[];
  capitols: CapitolOptions[];
  roads: WorkOrderOptions[];
  subCapitols: SubCapitolOptions[];
  predefinedOrders: predefineOrder[];
  activitys: WorkOrderOptions[];
  // Operarios activos del tenant para el selector "Operario que registra"
  // (solo se pobla en creación/edición de Actuación y Accidente).
  operators?: WorkOrderOptions[];
  // Usuarios app para el «Operario» del formulario de DUPLICAR (solo ahí).
  appUserOptions?: WorkOrderOptions[];
  assets: AssetsOptions[];
  elementOrders: ElementOrdersOptions[];
  teams: equipmentTypes[];
};

export type WorkOrder = {
  id?: string;
  type?: string;
  actionActivity?: string;
  actionElementOrder?: string;
  // Operario que registra (persona real, distinta de la cuenta de login).
  registeredByUserId?: string;
  // Autor elegido al DUPLICAR (Order.userId del duplicado). En el resto de
  // formularios no existe: el autor es el logueado.
  userId?: string;
  roid: string;
  operator: string;
  registerInitDate: string;
  registerEndDate: string;
  derivedEndDate?: string | null;
  predefine: string;
  capitol: string;
  subCapitol: string;
  classification: string;
  teams: string[];
  team?: string;
  teamRelationships?: string;
  concession: string;
  city: string;
  pkInitRoad: string;
  pkEndRoad: string;
  road: string;
  roadDirections: string;
  pkInit: string;
  pkEnd: string;
  track: string;
  direction: 'top' | 'down' | 'both' | typeof UNSPECIFIC;
  margin: 'left' | 'right' | 'both' | typeof UNSPECIFIC;
  lane: string;
  campaign: string;
  description: string;
  notes?: string;
  isCampaignActive: string;
  intent?: string;
} & GroupTypes;
